// The view switch's rows: their labels and the design's order (Figma 1047:37201).

/** Which page the workspace shows: the ticket list (one of its views), the automation review, follow-ups, a Benchmark list or its monitoring. */
export type WorkspaceView = 'tickets' | 'automation' | 'followups' | 'benchmark' | 'monitoring';

/** One row of the switch. The ticket list's views are rows of their own. */
export type ViewOption = 'mine' | 'all' | 'automation' | 'unassigned' | 'followups' | 'benchmark';

export const VIEW_LABELS: Record<ViewOption, string> = {
  mine: 'My tickets',
  all: 'All Kim tickets',
  automation: 'Automation review',
  unassigned: 'Unassigned tickets',
  followups: 'Follow up action',
  benchmark: 'Benchmark',
};

/** The design's order. Benchmark, when shown, comes last. */
export const VIEW_ORDER: readonly ViewOption[] = ['mine', 'all', 'automation', 'unassigned', 'followups', 'benchmark'];

export type ViewCounts = Partial<Record<ViewOption, number>>;
